import React from 'react';
import { Tag, Typography } from 'antd';
import type { FinanceReadinessProjection } from '../../routes/execution/dashboardProjection';
import {
  documentReadinessSymbol,
  documentReadinessTagColor
} from '../../operationalDomain/finance/documentReadiness';

const { Text } = Typography;

type Props = {
  finance: FinanceReadinessProjection;
};

function docTag(line: FinanceReadinessProjection['documentLines'][number]) {
  return (
    <Tag color={documentReadinessTagColor(line.state)} style={{ margin: 0 }}>
      {line.label} {documentReadinessSymbol(line.state)}
    </Tag>
  );
}

export const FinanceCompactStrip: React.FC<Props> = ({ finance }) => {
  const reason =
    finance.blockers.length > 0
      ? finance.blockers.map((b) => b.message).join(' · ')
      : finance.blockedReasons.length > 0
        ? finance.blockedReasons.join(' · ')
        : finance.blocked
          ? finance.detail
          : null;

  const lines =
    finance.documentLines.length > 0
      ? finance.documentLines
      : [
          {
            key: 'invoice' as const,
            label: 'Счёт',
            state: finance.invoiceReady ? ('verified' as const) : ('missing_required' as const),
            verified: finance.invoiceReady
          },
          {
            key: 'upd' as const,
            label: 'УПД',
            state: finance.updReady ? ('verified' as const) : ('missing_required' as const),
            verified: finance.updReady
          },
          {
            key: 'originals' as const,
            label: 'Ориг.',
            state: finance.originalsReady ? ('verified' as const) : ('missing_required' as const),
            verified: finance.originalsReady
          }
        ];

  return (
    <section className="execution-workspace__finance-strip">
      <div className="execution-workspace__finance-row">
        <Text strong style={{ fontSize: 12, marginRight: 6 }}>
          Финансы:
        </Text>
        {lines.map((line) => (
          <React.Fragment key={line.key}>{docTag(line)}</React.Fragment>
        ))}
        <Tag
          color={finance.blocked ? 'error' : finance.allReady ? 'success' : 'warning'}
          style={{ margin: 0 }}
        >
          {finance.blocked ? 'Заблокировано' : finance.allReady ? 'Готово' : 'В работе'}
        </Tag>
      </div>
      {reason ? (
        <Text className="execution-workspace__muted" style={{ fontSize: 11, display: 'block', marginTop: 4 }}>
          Причина: {reason}
        </Text>
      ) : null}
    </section>
  );
};

export default FinanceCompactStrip;
